// extracted by mini-css-extract-plugin
module.exports = {"LongTermReliability":"LongTermReliability_LongTermReliability__JJLpN"};